import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbPopoverConfig, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { MuiPopoverDirective } from './mui-popover.directive';

@NgModule({
  declarations: [MuiPopoverDirective],
  imports: [CommonModule, NgbPopoverModule],
  exports: [MuiPopoverDirective]
})
export class MuiPopoverModule {
  constructor(private config: NgbPopoverConfig) {
    config.autoClose = false;
    config.container = 'body';
    config.triggers = 'mouseenter:mouseleave touchstart';
    config.popoverClass = 'mui-popover';
    config.placement = 'top';
  }
}
